import React, { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const EmbedAuthPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  const params = useMemo(() => new URLSearchParams(location.search), [location.search]);

  useEffect(() => {
    const token = params.get('token');
    const next = params.get('next') || '/';

    if (!token) {
      setError('Missing authentication token.');
      return;
    }

    try {
      localStorage.setItem('authToken', token);
      window.setTimeout(() => {
        navigate(next.startsWith('/') ? next : '/', { replace: true });
      }, 120);
    } catch (err) {
      setError('Unable to complete sign-in handoff.');
    }
  }, [navigate, params]);

  return (
    <div style={{ maxWidth: 680, margin: '4rem auto', padding: '1.25rem', textAlign: 'center' }}>
      <h1 style={{ marginBottom: '0.75rem' }}>Signing you in…</h1>
      {!error && <p>Finalizing secure access to RSMIN.</p>}
      {error && <p style={{ color: '#b91c1c' }}>{error}</p>}
    </div>
  );
};

export default EmbedAuthPage;
